const respImgQuery = `
  altText
  sourceUrl
  mediaType
  id
`

export default respImgQuery